var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("template-card", {
    attrs: {
      name: _vm.name,
      "preview-width": "120px",
      "preview-height": "20px",
      icon: "$paper_phone"
    },
    on: {
      "dragend:item": function($event) {
        return _vm.addItemDrop()
      },
      "click:item": function($event) {
        return _vm.addItem()
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }